import CTA12 from './CTA12.js'
export default CTA12
